export const OTHER_ACCOUNT_ID = 'OTHER'

const BASE_NEW_ACCOUNT = [
  'amount',
  'name',
  'last_name',
  'bank_statement',
  'csf',
  'password',
  'bank_id',
]

export const FIELDS_EXISTING = [
  'amount',
  'method',
  'cashout_account_id',
  'password',
  'name',
  'last_name',
]

// Caso "sin cuentas registradas" (siempre card + validación last4)
export const FIELDS_NEW_UNVERIFIED = [
  ...BASE_NEW_ACCOUNT,
  'card',
  'bank_id',
  'method',
  'card_number',
]

export const getRequiredFields = ({
  defaultCashoutAccountId,
  selectedCashoutAccountId,
  method,
}) => {
  const hasDefault = defaultCashoutAccountId != null && defaultCashoutAccountId !== ''
  const wantsOther = String(selectedCashoutAccountId ?? '') === OTHER_ACCOUNT_ID

  // 1) Cuenta registrada normal
  if (hasDefault && !wantsOther) {
    return FIELDS_EXISTING
  }

  // 2) No tiene cuentas registradas
  if (!hasDefault) {
    return FIELDS_NEW_UNVERIFIED
  }

  // 3) Tiene cuentas pero eligió OTHER
  //    method define si pedimos clabe o card_number
  const fields = [...BASE_NEW_ACCOUNT, 'method', 'cashout_account_id', 'bank_id']

  if (method === 'spei') fields.push('clabe')

  if (method === 'card') {
    fields.push('card_number')
    fields.push('card')
  }

  return fields
}